import React, { useEffect } from 'react'
import ServiceCard from '../SubComponents/ServiceCard'
import Aos from "aos"
import 'aos/dist/aos.css'

export default function CommonServices() {
  useEffect(() => {
    document.addEventListener("DOMContentLoaded" , () => {
      setTimeout(() => {
        Aos.refresh();
      },500)
    })
    Aos.init({duration:1000});
  },[])
  return (
    <>
      <div className="servicesSection">

        <div className="serviceWrapper">

        <div className="detailBlock">
            <h3>Our Services</h3>
            <h2>What We Do?</h2>
        </div>
        <div className="detailCard" >
        <ServiceCard title={"Interior Design"} icon={"fa-light fa-paint-roller"} dataaos={"fade-up"} delay={"100"} />
         <ServiceCard title={"Design Consultancy"} icon={"fa-light fa-chalkboard"} dataaos={"fade-up"} delay={"300"}/>
         <ServiceCard title={"Residential Design"} icon={"fa-light fa-house"} dataaos={"fade-up"} delay={"500"}/>
         <ServiceCard title={"Commercial Design"} icon={"fa-light fa-briefcase"} dataaos={"fade-up"} delay={"100"}/>
         <ServiceCard title={"Hospitality Design"} icon={"fa-light fa-handshake"} dataaos={"fade-up"} delay={"300"}/>
         <ServiceCard title={"Co-working Space Design"} icon={"fa-light fa-hand-holding-seedling"} dataaos={"fade-up"} delay={"500"}/>
        </div>

        </div>
      </div>
    </>
  )
}
